import styled from 'styled-components';

export const StyledStepFourExecutorAdmission = styled.div`
  
  h2{
    font-size: 28px;
    line-height: 24px;
  }
  
  .body{
    margin: 32px 72px 0 72px;
  }
  
  .ant{
    &-alert-success{
      background: rgba(81, 37, 143, 0.2);
      margin-bottom: 32px;
    }
    
    &-alert-content{
      p{
        margin-bottom: 0;
      }
      
      span{
        font-weight: 600;
      }
    }
    
    &-form-item{
      position: relative;
    
      display: flex;
      flex-direction: column;
    
      padding-bottom: 16px;
      margin-bottom: 20px;
      margin-top: 20px;
      
      &-row{
        padding-bottom: 32px;
        flex-direction: column;
      }
      
      &:not(:last-child){
        border-bottom: 1px dashed rgba(191, 197, 209, 0.3);
      }
      
      &-label{
        text-align: left;
        width: 80%;
                
        & > label{
          display: block;
          font-weight: 400;
          font-size: 18px;
          line-height: 24px;
          color: #383B41;
          height: auto;
          text-wrap: pretty;
          margin-bottom: 0;
        }
      }
      
      &-control{
        position: static;
        flex-direction: column-reverse;
        
        &-input{
          min-height: auto;
          position: static;
        }
        
        .ant-upload-select{
          position: absolute;
          right: 0;
          top: -8px;
        }
        
        .ant-upload-list{
          position: absolute;
          left: 0;
          top: 38px;
        }
      }
    }
        
    
    &-upload-text-icon{
      display: none;
    }
    
    &-upload-list-item-progress{
      padding-left: 0;
      
      .ant-progress-inner{
        margin-top: 8px;
      }
    }
    
    &-upload-list-text{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      
      &-container{
        border: 1px solid rgba(191, 197, 209, 0.5);
        border-radius: 4px;
        margin-top: 16px;

        
        &:not(:last-child){
          margin-right: 8px;
        }
        
        &:hover{
          cursor: pointer;
          border-color: #ED1C24;
          
          .ant-upload-list-item:hover .ant-upload-list-item-info{
            background: transparent;
          }
          
          .ant-upload-list-item-card-actions .anticon{
             color: #ED1C24;
          }
        }
        
        .ant-upload-list-item{
          margin-top: 0;
        }
        
        .ant-upload-list-item-card-actions .anticon, .ant-upload-list-item-name{
          color: #383B41;
        }
      }
    }
  }

`
